import { cn } from "@/lib/cn";
import { initialsOf } from "@/lib/formatters";

export type AvatarColor = "blue" | "violet" | "green" | "amber" | "red";

const COLORS: Record<AvatarColor, string> = {
  blue: "bg-info-dim text-info",
  violet: "bg-violet-dim text-violet",
  green: "bg-success-dim text-success",
  amber: "bg-warning-dim text-warning",
  red: "bg-danger-dim text-danger",
};

/** Deterministically pick a color from a name so it's stable across renders. */
export function colorForName(name: string): AvatarColor {
  const palette: AvatarColor[] = ["blue", "violet", "green", "amber", "red"];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return palette[hash % palette.length]!;
}

export function Avatar({
  name,
  color,
  size = 28,
  className,
}: {
  name: string;
  color?: AvatarColor;
  size?: number;
  className?: string;
}) {
  const tone = color ?? colorForName(name);
  return (
    <div
      className={cn("flex items-center justify-center rounded-full border border-white/10 font-bold shrink-0", COLORS[tone], className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
    >
      {initialsOf(name)}
    </div>
  );
}
